// extracted by mini-css-extract-plugin
module.exports = {"container":"Confirmation_container__yOuJK","confirmation":"Confirmation_confirmation__3JKmT"};